
export const HIVE_NODES = [
  "https://api.deathwing.me",
  "https://api.hive.blog",
  "https://hived.emrebilir.me",
  "https://rpc.syncad.com",
  "https://api.openhive.network"
];

export const APP_TITLE = "Powerdown Tracker";
export const INSTALLMENTS_TOTAL = 13;
export const DAYS_BETWEEN_PAYOUTS = 7;
